export const BxsClearRocket = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.92 0.384C18.857 0.368 17.364 0 15.496 0C12.911 0 10.833 0.713 9.485 2.061C7.997 3.549 6.857 4.712 6.31 5.273C5.096 5.136 2.233 5.07 0.293 7.011C0.105 7.198 0 7.452 0 7.718C0 7.984 0.105 8.238 0.293 8.425L11.606 19.738C11.794 19.926 12.047 20.031 12.313 20.031C12.579 20.031 12.833 19.926 13.02 19.738C14.974 17.785 14.914 14.924 14.787 13.728L17.971 10.545C21.162 7.354 19.711 1.363 19.648 1.11C19.559 0.753 19.278 0.473 18.92 0.384ZM16.556 9.132L13.02 12.667C12.784 12.903 12.682 13.242 12.748 13.57C12.753 13.595 13.154 15.812 12.211 17.514L2.517 7.82C4.217 6.881 6.458 7.316 6.465 7.316C6.795 7.386 7.149 7.28 7.388 7.033C7.391 7.03 8.794 5.58 10.9 3.474C12.118 2.256 14.071 2 15.496 2C16.443 2 17.289 2.111 17.827 2.203C18.071 3.634 18.452 7.235 16.556 9.132Z"
        fill="#272D41"
      />
      <path d="M3 14C1 15 1 19 1 19C1 19 4 19 6 17L3 14Z" fill="#272D41" />
      <path
        d="M13.728 8.304C14.8326 8.304 15.728 7.40857 15.728 6.304C15.728 5.19943 14.8326 4.304 13.728 4.304C12.6234 4.304 11.728 5.19943 11.728 6.304C11.728 7.40857 12.6234 8.304 13.728 8.304Z"
        fill="#272D41"
      />
    </svg>
  )
}

export default BxsClearRocket
